export default "__VITE_ASSET__h$OlcsBx__"